import React from "react";
import PropTypes from "prop-types";

import { SECTION_LABEL } from "./ReviewSummary";

/**
 * Step 6 — final confirmation after every section is Save-and-nexted.
 * Small centered dialog: green check + N-items summary + per-section
 * breakdown + Done button. Done tears down the modal.
 *
 * Note (Phase 4 pending): the "N items reviewed & saved" count reflects
 * items that hit `POST /section/:section/save` successfully. Until the
 * target-service fan-out lands, those POSTs only flip transcript state
 * to `reviewed_and_saved` — no rows are yet in CC v2 / Dx v2 / Med v2.
 * The dialog is deliberately quiet about that so demos don't confuse
 * reviewers; the caveat lives in the memory / TODO for wiring.
 */
const ReviewDone = ({ counts, onDone }) => {
  const sections = Object.keys(counts).filter((s) => counts[s] > 0);
  const total = sections.reduce((n, s) => n + counts[s], 0);

  return (
    <div className="ait-done" role="dialog" aria-modal="true" aria-label="Review complete">
      <button type="button" className="ait-done-close" aria-label="Close" onClick={onDone}>
        &times;
      </button>
      <div className="ait-done-body">
        <div className="ait-done-check" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="none"
               stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <h2 className="ait-done-title">
          All {total} {total === 1 ? "item" : "items"} reviewed &amp; saved
        </h2>
        {sections.length > 0 ? (
          <p className="ait-done-breakdown">
            {sections.map((s, i) => (
              <React.Fragment key={s}>
                {i > 0 ? <span className="ait-done-sep"> · </span> : null}
                {SECTION_LABEL[s] || s}{" "}
                <strong>{counts[s]}</strong>
              </React.Fragment>
            ))}
          </p>
        ) : null}
        <button type="button" className="ait-done-cta" onClick={onDone}>Done</button>
      </div>
    </div>
  );
};

ReviewDone.propTypes = {
  counts: PropTypes.object.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default ReviewDone;
